export default 'statsApp';
